import { Badge } from '@monksflow/monks-ui';
import { microInteraction } from '@/shared/ui/MicroInteractions';
import type { BriefTemplateStatusBadgeProps } from './BriefTemplateStatusBadge.types';
import { resolveStatusBadge } from './BriefTemplateStatusBadge.utils';

export function BriefTemplateStatusBadge(props: BriefTemplateStatusBadgeProps) {
  const { label, variant } = resolveStatusBadge(props.status, props.enabled);

  return (
    <Badge variant={variant} roundness="full" className={microInteraction.statusBadge}>
      {label}
    </Badge>
  );
}
